<template>
    <div class="content-box">
        <img src="../assets/icons/work.svg" alt="" class="icon" v-if="isWork"/>
        <img src="../assets/icons/school.svg" alt="" class="icon" v-else/>
        <div class="content-details">

            <div class="inst">{{ ins }}</div>
            <div class="title">{{ title }}</div>
            <div class="location">{{ location }}</div>
            <div class="years">{{ years }}</div>
            <div class="details">
                {{ details }}
            </div>
        </div>
    </div>
</template>
<script>
export default{
    props:{
        isWork: Boolean,
        ins: String,
        title: String,
        location: String,
        years: String,
        details: String
    }
}
</script>
<style scoped>
.content-box{
    display: flex;
    padding-bottom:1rem;
    margin-bottom: 2rem;
    border-bottom:2px solid var(--light);
}

.icon{
    height:4rem;
    margin-right:0.8rem;
}


.inst{
    /* color:var(--blue); */
    font-family: var(--heading);
    font-size:1.2rem;   
}

.title{
    font-family: var(--heading);
    /* color:var(--gold3); */
}

.details{
    margin-top:0.5rem;
}

.years, .location{
    font-size:0.9rem;
}

@media(max-width: 768px){
    
.work{
    padding:1rem;
}

.location{
    color:var(--grey);
}

.inst{
    /* color:var(--blue); */
    font-family: var(--heading);
    font-size:1.1rem;   
}

}
</style>